import { createContext } from 'react'
import type { supportApi } from '@/lib/supportApi'

export type SupportAdminSession = Awaited<ReturnType<typeof supportApi.adminSession>>
export const SupportAdminSessionContext = createContext<SupportAdminSession | null>(null)
